import { ourMembersData } from "src/data/staticData";
import MemberCard from "../../shared/midcomponents/MemberCard/MemberCard";
import s from "./OurMembersSection.module.scss";

const OurMembersSection = () => {
  return (
    <section className={s.ourMembersSection}>
      {ourMembersData.map((member) => (
        <MemberCard key={member.id} data={member} />
      ))}
    </section>
  );
};
export default OurMembersSection;
